import React, { useEffect } from 'react';
import { Route, useHistory, useRouteMatch } from 'react-router-dom';
import MockupView from './index';
import PavementProjects from './PavementProjects';
import PavementOrders from './PavementOrders';
import PavementStatus from './PavementStatus';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { ERoutes } from '../../../../../routes';

export enum EMockupViewRoutes {
  PAVEMENT_PROJECTS = '/pavement-projects',
  PAVEMENT_ORDERS = '/pavement-orders',
  PAVEMENT_STATUS = '/pavement-status'
}

const MockupViewRoutes: React.FC = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const mockupsState = useSelector(
    (appState: ApplicationState) => appState.fabricationMockups
  );

  useEffect(() => {
    if (!mockupsState.saveMockupState?.editingMockupId) {
      history.push(ERoutes.PROJECT_MOCKUP);
    }
  });

  return (
    <>
      <Route path={`${path}`} exact component={MockupView} />

      <Route
        path={`${path}${EMockupViewRoutes.PAVEMENT_PROJECTS}`}
        component={PavementProjects}
      />

      <Route
        path={`${path}${EMockupViewRoutes.PAVEMENT_ORDERS}`}
        component={PavementOrders}
      />

      <Route
        path={`${path}${EMockupViewRoutes.PAVEMENT_STATUS}`}
        component={PavementStatus}
      />
    </>
  );
};

export default MockupViewRoutes;
